export default {
    state: {
        provinceList: [], // 省份
        acquiesce: {}
    },
    getters: {

    },
    mutations: {
        getProvinceList(state, provinceList) { // 
            state.provinceList = provinceList
        },
        setAcquiesce(state, provinceObj) {
            state.acquiesce = provinceObj
        }
    },
    actions: {

    }
}



// WEBPACK FOOTER //
// ./src/store/modules/baseProvinceList.js